import React, { useEffect, useState } from 'react';
import { getLoginInfoMessage, login } from '../utils/auth';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loginInfoMessage, setLoginInfoMessage] = useState('');

  useEffect(() => {
    getLoginInfoMessage()
      .then(setLoginInfoMessage)
      .catch(() => setLoginInfoMessage(''));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const user = await login(username, password);
      onLogin(user.username, user);
    } catch (err) {
      setError(err.message || 'Invalid username or password');
    }
  };

  const inputClass =
    'w-full text-sm text-ink bg-surface border border-line-strong rounded-tc-sm px-3.5 py-3 min-h-[46px]';

  return (
    <div className="tc-login-glow min-h-screen flex flex-col items-center justify-center gap-5 px-6 py-14 text-ink">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-[420px] bg-surface border border-line rounded-tc-xl px-9 pt-10 pb-8 shadow-sm"
      >
        <div className="flex flex-col items-center gap-3.5 text-center">
          <svg width="28" height="28" viewBox="0 0 32 32" role="img" aria-label="MPG">
            <path fill="#FA5041" d="M11.9 2.6h8.2l-1.5 14.9h-5.2z" />
            <path fill="#FA5041" d="M16 29.4c0 0-6.4-4.1-6.4-7.9 0-2.1 1.6-3.4 3.3-3.4 1.3 0 2.5.8 3.1 1.9.6-1.1 1.8-1.9 3.1-1.9 1.7 0 3.3 1.3 3.3 3.4 0 3.8-6.4 7.9-6.4 7.9z" />
          </svg>
          <h1 className="font-display text-[38px] leading-[1.05] tracking-tight">Time Creative</h1>
          <p className="mt-2 text-xs tracking-[0.3em] text-muted">design ops</p>
        </div>

        <hr className="my-6 border-0 border-t border-line" />

        {error && (
          <p role="alert" className="text-[13px] text-danger-ink bg-danger-soft border border-danger/30 rounded-tc-sm px-3 py-2 mb-3">
            {error}
          </p>
        )}

        <div className="flex flex-col gap-1.5 mb-4">
          <label htmlFor="login-username" className="text-[13px] font-medium">Username</label>
          <input
            id="login-username"
            type="text"
            autoComplete="username"
            className={inputClass}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>

        <div className="flex flex-col gap-1.5 mb-4">
          <label htmlFor="login-password" className="text-[13px] font-medium">Password</label>
          <input
            id="login-password"
            type={showPassword ? 'text' : 'password'}
            autoComplete="current-password"
            className={inputClass}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <div className="flex items-center gap-2 mb-5">
          <input
            id="login-show-password"
            type="checkbox"
            style={{ accentColor: 'rgb(var(--tc-accent))' }}
            checked={showPassword}
            onChange={(e) => setShowPassword(e.target.checked)}
          />
          <label htmlFor="login-show-password" className="text-[13px] text-muted">Show password</label>
        </div>

        <button type="submit" className="w-full bg-accent text-white text-sm font-semibold rounded-tc-sm py-3.5 min-h-[48px]">
          Sign in
        </button>
      </form>

      <p className="text-[11.5px] tracking-wide text-muted text-center">MPG internal app</p>

      {loginInfoMessage && (
        <div className="w-full max-w-[420px] bg-surface-alt border border-line rounded-tc-lg p-4">
          <h3 className="text-[10px] font-semibold uppercase tracking-[0.13em] text-muted mb-2">Notice</h3>
          <p className="text-[12.5px] leading-relaxed whitespace-pre-wrap">{loginInfoMessage}</p>
        </div>
      )}
    </div>
  );
}
